export default "__VITE_ASSET__BMQ03Cpl__"